module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/empty-list-pattern/empty-list-pattern.component.scss
// module id = ./src/app/shared-components/empty-list-pattern/empty-list-pattern.component.scss
// module chunks = main